<template>
    <div>
        <h1 class="q-display-1">Edytor odznaki</h1>
        <badge-component
            v-if="localModel"
            :model="localModel"
            :inEdit="true"/>

        <fixed-buttons>
            <q-btn
                flat
                style="font-size: 1.5rem" dense
                icon="save"
                color="primary"
                @click="save(true)">
                <q-tooltip anchor="top left">
                    Zapisz i zamknij
                </q-tooltip>
            </q-btn>

            <q-btn
                flat
                style="font-size: 1.5rem" dense
                icon="save"
                color="secondary"
                @click="save">
                <q-tooltip anchor="top left">
                    Zapisz i edytuj dalej
                </q-tooltip>
            </q-btn>
        </fixed-buttons>
    </div>
</template>

<script>
    import QCard from 'quasar-framework/src/components/card/QCard'
    import QCardTitle from 'quasar-framework/src/components/card/QCardTitle'
    import ImageViewer from './pole/viewers/ImageViewer'
    import QCardMedia from 'quasar-framework/src/components/card/QCardMedia'
    import BadgeComponent from './BadgeComponent'
    import FixedButtons from './FixedButtons'
    import QTooltip from 'quasar-framework/src/components/tooltip/QTooltip'
    import QBtn from 'quasar-framework/src/components/btn/QBtn'
    export default {
        name: 'BadgeEditor',
        props: ['model', 'inline', 'inEdit'],
        data () {
            return {
                localModel: undefined,
                emptyModel: {
                    label: 'Nowa odznaka',
                    description: '',
                    thumbUrl: '',
                    badgeId: this.$uuid()
                }
            }
        },
        mounted () {
            if (this.badge) {
                this.localModel = {
                    ...this.badge
                }
            }

            this.$store.commit('showRightMenu', {
                showPicture: true,
            })

            this.$on('hook:beforeDestroy', () => {
                this.$store.commit('showRightMenu', false)
            })
        },
        computed: {
            badge () {
                return this.$store.getters.badge.find(b => b.badgeId === this.$route.params.badgeId) || this.emptyModel
            },
            editMode () {
                return this.$route.params.badgeId !== undefined
            }
        },
        watch: {
            badge (curr) {
                this.localModel = {
                    ...curr
                }
            }
        },
        components: {QBtn, QTooltip, FixedButtons, BadgeComponent, QCardMedia, ImageViewer, QCardTitle, QCard},
        methods: {
            save (exitAfterSave) {
                const method = this.editMode ? 'update' : 'create'

                this.$store.dispatch(method, {
                    what: 'badge',
                    id: this.localModel.badgeId,
                    item: this.localModel
                }).then(() => {
                    if (exitAfterSave) {
                        this.$router.push({name: 'badges'})
                    }
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .card {
        width: 150px;
        border-radius: 20px;

        img {
            width: 100px;
            margin: 0 auto;
        }

        .actions {
            background-color: gainsboro;
        }
    }
</style>